import BigNumber from 'bignumber.js'
import { ChainId, FactoryVersion } from '@nominex/nomiswap-sdk'
import { SerializedFarmConfig } from 'config/farms'
import { BIG_TEN, BIG_TWO } from 'config/constants/bigNumber'
import { fetchLpData } from './fetchLpData'
import { fetchStakingServiceData } from './fetchStakingServiceData'
import { getFarmPrices } from './getFarmPricesV2'

function lpTransformer(lpResult, stakingServiceResult) {
  return (farm, index) => {
    const [tokenBalanceLP, quoteTokenBalanceLP, lpTotalSupply, tokenDecimals, quoteTokenDecimals] = lpResult[index]
    const [totalStaked] = stakingServiceResult[index]

    // Ratio in % of LP tokens that are staked in the staking service, vs the total number in circulation
    const lpTokenRatio = new BigNumber(totalStaked).div(new BigNumber(lpTotalSupply))
    // Raw amount of token in the LP, including those not staked
    const tokenAmountTotal = new BigNumber(tokenBalanceLP).div(BIG_TEN.pow(tokenDecimals))
    const quoteTokenAmountTotal = new BigNumber(quoteTokenBalanceLP).div(BIG_TEN.pow(quoteTokenDecimals))
    // Total staked in LP, in quote token value
    const lpTotalInQuoteToken =
      farm.version === FactoryVersion.V2
        ? tokenAmountTotal.plus(quoteTokenAmountTotal)
        : quoteTokenAmountTotal.times(lpTokenRatio).times(BIG_TWO)

    return {
      ...farm,
      tokenAmountTotal: tokenAmountTotal.toJSON(),
      quoteTokenAmountTotal: quoteTokenAmountTotal.toJSON(),
      lpTotalSupply: new BigNumber(lpTotalSupply).toFixed(18),
      lpTotalInQuoteToken: lpTotalInQuoteToken.toFixed(18),
      tokenPriceVsQuote: quoteTokenAmountTotal.div(tokenAmountTotal).toFixed(18),
    }
  }
}

const fetchFarms = async (farmsToFetch: SerializedFarmConfig[], chainId: ChainId) => {
  const [lpResult, stakingServiceResult] = await Promise.all([
    fetchLpData(farmsToFetch, chainId),
    fetchStakingServiceData(farmsToFetch, chainId),
  ])

  const lpFarms = farmsToFetch.map(lpTransformer(lpResult, stakingServiceResult))

  return getFarmPrices(lpFarms, chainId)
}

export default fetchFarms
